/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import {
  HousePlanBulkUpdateAutocompleteDto,
  HousePlanBulkUpdateDto,
} from '../models/house-plan-bulk.dto';

export const HousePlanBulkUpdateMapper = entity<HousePlanBulkUpdateDto>();
export const HousePlanBulkUpdateAutocompleteMapper = entity<HousePlanBulkUpdateAutocompleteDto>();
